import { BrowserRouter } from 'react-router-dom'

import { AppProviders } from './app/AppProviders'
import { AppRoutes } from './app/AppRoutes'
import { Toaster } from './ui/Toaster/Toaster'

export function App() {
  return (
    <AppProviders>
      <BrowserRouter>
        <AppRoutes />
        <Toaster />
      </BrowserRouter>
    </AppProviders>
  )
}
